import { call, put, takeLatest } from "redux-saga/effects";
import { GET_TRANSPORTATION_MANAGEMENT_DATA, POST_TRANSPORTATION_MANAGEMENT_DATA, UPDATE_TRANSPORTATION_MANAGEMENT_DATA, DELETE_TRANSPORTATION_MANAGEMENT_DATA, DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA, UPLOAD_TRANSPORTATION_MANAGEMENT_DATA, GET_VEHICLE_REGNUMBER_DETAILS, GET_TTBIL_ROUTE_CODE_DETAILS, TOAST_SUCCESS, TOAST_ERROR, GET_AUDIT_LOG_DETAILS } from "Constants/actionConstants";
import { GET_TRANSPORTATION_MANAGEMENT_URL, POST_TRANSPORTATION_MANAGEMENT_URL, UPDATE_TRANSPORTATION_MANAGEMENT_URL, DELETE_TRANSPORTATION_MANAGEMENT_URL, DOWNLOAD_TRANSPORTATION_MANAGEMENT_URL, UPLOAD_TRANSPORTATION_MANAGEMENT_URL, GET_VEHICLE_REGNUMBER_DETAILS_URL, GET_TTBIL_ROUTE_CODE_DETAILS_URL, GET_AUDIT_LOG_DETAILS_URL } from "Utils/api";
import axiosT1 from "Utils/axios";
import { downloadUrl } from "Utils/index";


export function* getTransportationManagementData(action) {
    try {
        const resData = yield call(
          axiosT1.get,
          GET_TRANSPORTATION_MANAGEMENT_URL,
          {
            params: action.params,
          }
        );
        if(action.onSuccess) {
          action.onSuccess(resData.data && resData.data.data || {});
        }
      } catch (e) {
        console.log("e:", e);
        if(e.response && e.response.data) {
          yield put({
            type: TOAST_ERROR,
            message: (e.response.data || {}).message
          });
        }
      }
}

export function* addTransportationManagementData(action) {
    try {
        const resData = yield call(axiosT1.post, POST_TRANSPORTATION_MANAGEMENT_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: (resData.data || {}).message
        });
    } catch(e) {
        console.log("e:", e);
        if(e.response && e.response.data) {
          yield put({
            type: TOAST_ERROR,
            message: (e.response.data || {}).message
          });
        }
    }
}

export function* downloadTransportationManagementTemplate(action) {
  try {
    const resData = yield call(axiosT1.get, DOWNLOAD_TRANSPORTATION_MANAGEMENT_URL, 
      {
        params: action.params,
      }
    );
    if(resData.data.data && resData.data.data.link) {
      downloadUrl(resData.data.data.link);
    }
  } catch(e) {
      console.log("e:", e);
  }
}

export function* uploadTransportationManagementDetails(action) {
  try {
    const resData = yield call(axiosT1.post, UPLOAD_TRANSPORTATION_MANAGEMENT_URL, action.payload, { params: action.params });
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
  });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* updateTransportationManagementData(action) {
  try {
    const resData = yield call(axiosT1.put, UPDATE_TRANSPORTATION_MANAGEMENT_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* deleteTransportationManagementData(action) {
  try {
    const resData = yield call(axiosT1.delete, DELETE_TRANSPORTATION_MANAGEMENT_URL, {
      params: action.data
    });
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* getVehicleNumberDetails(action) {
  try {
    const resData = yield call(axiosT1.get, GET_VEHICLE_REGNUMBER_DETAILS_URL, { params: action.params });
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data || []);
    }
  } catch(e) {
    console.log("e:", e);
    if(e.response && e.response.data) {
      yield put({
        type: TOAST_ERROR,
        message: (e.response.data || {}).message
      });
    }
  }
}

export function* getTTBilRouteCodeDetails(action) {
  try {
    const resData = yield call(axiosT1.get, GET_TTBIL_ROUTE_CODE_DETAILS_URL, { params: action.params });
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data || []);
    }
  } catch(e) {
    console.log("e:", e);
    if(e.response && e.response.data) {
      yield put({
        type: TOAST_ERROR,
        message: (e.response.data || {}).message
      });
    }
  }
}

export function* getAuditLogData(action) {
    try {
        const resData = yield call(
          axiosT1.get,
          GET_AUDIT_LOG_DETAILS_URL,
          {
            params: action.params,
          }
        );
        if(action.onSuccess) {
          action.onSuccess(resData.data && resData.data.data || {});
        }
      } catch (e) {
        console.log("e:", e);
        if(e.response && e.response.data) {
          yield put({
            type: TOAST_ERROR,
            message: (e.response.data || {}).message
          });
        }
      }
}

export function* transportationManagementSaga() {
    yield takeLatest(GET_TRANSPORTATION_MANAGEMENT_DATA, getTransportationManagementData);
    yield takeLatest(POST_TRANSPORTATION_MANAGEMENT_DATA, addTransportationManagementData);
    yield takeLatest(DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA, downloadTransportationManagementTemplate);
    yield takeLatest(UPLOAD_TRANSPORTATION_MANAGEMENT_DATA, uploadTransportationManagementDetails);
    yield takeLatest(UPDATE_TRANSPORTATION_MANAGEMENT_DATA, updateTransportationManagementData);
    yield takeLatest(DELETE_TRANSPORTATION_MANAGEMENT_DATA, deleteTransportationManagementData);
    yield takeLatest(GET_VEHICLE_REGNUMBER_DETAILS, getVehicleNumberDetails);
    yield takeLatest(GET_TTBIL_ROUTE_CODE_DETAILS, getTTBilRouteCodeDetails);
    yield takeLatest(GET_AUDIT_LOG_DETAILS, getAuditLogData);
}